import React, { Component } from 'react';

import ImporterDateFilter from './ImporterDateFilter';
import ImporterBatchTool from './ImporterBatchTool';
import RestrictedComponent from '../../lib/components/form/RestrictedComponent';
import schema from '../../routes/permissions/schema';

class ImporterTools extends Component {
    constructor (props) {
        super(props);

        this.state = {};
    }

    render () {
        return (<div id="importer__tools">

            {
                // Only show the import button when there's data
                // @TODO: reset?
                <div className="row">
                    <div className="col-xs-12">
                        <div className="callout clearfix">
                            <RestrictedComponent permissionCheck={schema.EVENT.CREATE}>
                                <button className="btn btn-default"
                                    onClick={this.props.toggleUploadModal}
                                >
                                    <i className="fa fa-upload"/> 
                                    {this.props.csvData.length ? 'Upload Another CSV Document' : 'Upload CSV Document'}
                                </button>
                            </RestrictedComponent>
                        </div>
                    </div>
                </div>
            }

            <div className="row">
                <div className="col-md-6">
                    <div className="callout clearfix">
                        <h4 style={{padding: "0 1rem"}}>Batch Utilities</h4>
                        <hr/>
                        <ImporterBatchTool {...this.props}/>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="callout clearfix">
                        <h4 style={{padding: "0 1rem"}}>Data Filters</h4>
                        <hr/>
                        <ImporterDateFilter {...this.props}/>
                    </div>
                </div>
            </div>
        </div>);
    }
}

ImporterTools.propTypes = {};

export default ImporterTools;
